import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as MarkdownIt from 'markdown-it';
import { Blogpost } from '../../models/blogpost';

@Component({
  selector: 'app-blogposts',
  styleUrls: ["blogposts.component.scss"],
  templateUrl: './blogposts.component.html'
})
export class BlogpostsComponent {
  md = new MarkdownIt();
  public blogposts: Blogpost[];

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    http.get<Blogpost[]>(baseUrl + 'api/blogpost').subscribe(result => {
      this.blogposts = result;
    }, error => console.error(error));
  }
}


